const PHOTO =
  "https://customer-assets.emergentagent.com/job_session-booking-23/artifacts/z0xfl6x8_DSC_0274%281%29.jpg";

const DeeperProblem = () => (
  <section
    className="bg-[#F6F1EA] py-16 sm:py-20 border-t border-[#D7B2A3]/30"
    data-testid="deeper-problem-section"
  >
    <div className="max-w-[1200px] mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
      {/* Photo — soft-clay accent */}
      <div className="lg:col-span-5">
        <div className="relative aspect-[4/5] max-w-[320px] mx-auto lg:mx-0">
          <div className="absolute -top-4 -left-4 w-20 h-20 bg-[#D7B2A3]/60 z-0" />
          <div className="absolute -bottom-5 -right-4 w-24 h-24 border border-[#B89B63] z-0" />
          <img
            src={PHOTO}
            alt="A quiet morning — permission to sit with the questions"
            className="relative z-10 w-full h-full object-cover"
            data-testid="deeper-problem-photo"
          />
        </div>
      </div>

      {/* Copy */}
      <div className="lg:col-span-7">
        <div className="space-y-1.5 font-serif text-xl sm:text-2xl text-[#4F5D4F] leading-[1.3] tracking-tight" data-testid="deeper-problem-permissions">
          <p>You are allowed to question.</p>
          <p>You don't have to know where you'll land.</p>
          <p>You can change your mind.</p>
          <p>Admit something doesn't feel right anymore.</p>
          <p>Say, <em className="italic text-[#B89B63]">"I don't know yet."</em></p>
          <p>Explore what you actually believe.</p>
        </div>

        <div className="mt-6 space-y-3 text-base text-[#4F5D4F]/85 font-light leading-relaxed max-w-xl">
          <p>
            Your questions aren't something we need to fix. They're something we can get
            curious about.
          </p>
          <p>
            Together, we'll untangle what you've been taught from what feels true to you—so
            you can hear your own voice, trust your discernment, and make choices with more
            confidence and less fear.
          </p>
        </div>

        <div className="mt-6">
          <p className="text-xs tracking-eyebrow uppercase text-[#B89B63] mb-3">Imagine being able to...</p>
          <ul className="space-y-1 font-serif italic text-base sm:text-lg text-[#4F5D4F]/90 leading-snug" data-testid="deeper-problem-imagine">
            <li>Ask hard questions without spiraling.</li>
            <li>Trust yourself without needing everyone else's approval.</li>
            <li>Honor what you need without drowning in guilt.</li>
            <li>Explore faith with curiosity instead of fear.</li>
            <li>Make decisions that actually feel like yours.</li>
          </ul>
        </div>

        <div className="mt-6 border-l-2 border-[#B89B63] pl-5 space-y-1 max-w-xl">
          <p className="font-serif italic text-lg sm:text-xl text-[#4F5D4F] leading-snug">
            You don't need me to give you the answers.
          </p>
          <p className="font-serif italic text-lg sm:text-xl text-[#4F5D4F] leading-snug">
            You need a safe place to discover your own—and become the woman{" "}
            <em className="text-[#B89B63]">you</em> get to define.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default DeeperProblem;
